import React from 'react';
import { Router } from '@/components/router';
import { AppProviders } from '@/app/providers';
import { LoginForm } from '@/features/auth/components/LoginForm';
import { OTPForm } from '@/features/auth/components/OTPForm';
import { Dashboard } from '@/components/Dashboard';
import { useAuth } from '@/features/auth/hooks/use-auth';

// Authentication wrapper components
function AuthLoginPage() {
  const { handleLogin, handleLoginError, isLoading, error } = useAuth();
  return (
    <LoginForm
      onLogin={handleLogin}
      onLoginError={handleLoginError}
      isLoading={isLoading}
      error={error}
    />
  );
}

function AuthOTPPage() {
  const { handleOTPSubmit, handleBackToLogin, isLoading, error, userName } = useAuth();
  return (
    <OTPForm
      onOTPSubmit={handleOTPSubmit}
      onBack={handleBackToLogin}
      isLoading={isLoading}
      error={error}
      userName={userName}
    />
  );
}

function AuthDashboardPage() {
  const { user, handleLogout } = useAuth();

  if (!user) return null;

  return <Dashboard user={user} onLogout={handleLogout} />;
}

// Route configuration
export const routes = [
  {
    path: "/",
    component: AuthLoginPage,
    title: "Login - 360welfare Token Sharing",
    description: "Login with your Polimi credentials to access the platform"
  },
  {
    path: "/login",
    component: AuthLoginPage,
    title: "Login - 360welfare Token Sharing",
    description: "Login with your Polimi credentials to access the platform"
  },
  {
    path: "/otp",
    component: AuthOTPPage,
    title: "Two-Factor Authentication - 360welfare Token Sharing",
    description: "Enter your verification code to complete authentication"
  },
  {
    path: "/dashboard",
    component: AuthDashboardPage,
    title: "Dashboard - 360welfare Token Sharing",
    description: "Manage your groups and generate welfare tokens"
  },
];

// Main App component
export function App() {
  return (
    <AppProviders routes={routes}>
      <Router routes={routes} />
    </AppProviders>
  );
}

export default App;